module.exports = __webpack_public_path__ + "img/OLED.6e3cda1d.jpg";